import { Controller } from '@hotwired/stimulus';
import { MDCTabBar } from '@material/tab-bar';

export default class extends Controller {
  static targets = ['bar', 'content'];
  static classes = ['displayNone'];

  connect() {
    this.tabBar = new MDCTabBar(this.barTarget);
    this.tabBar.listen('MDCTabBar:activated', (event) => {
      this.handleTabActivated(event);
    });
  }

  disconnect() {
    if (this.tabBar) {
      this.tabBar.destroy();
    }
  }

  handleTabActivated(event) {
    this.contentTargets.forEach((content) => {
      content.classList.add(this.displayNoneClass);
    });
    this.contentTargets[event.detail.index].classList.remove(
      this.displayNoneClass
    );
  }
}
